import React, { useCallback, useEffect, useRef, useState } from 'react'

import { Backdrop, ButtonV2, CardBody, CardFooter, CardHeader, Icon, Sheet, Text } from '@vividseats/vivid-ui-kit'
import router, { useRouter } from 'next/router'

import useTicketsNoLongerAvailable from '../../hooks/use-tickets-no-longer-available'

import styles from './styles.module.scss'

const TicketsNoLongerAvailable: React.FC = () => {
    // Initialize with false, otherwise it will break modal's slide-in animation
    const [isOpen, setIsOpen] = useState<boolean>(false)
    const timerRef = useRef<NodeJS.Timeout | undefined>(undefined)

    const { areTicketsNoLongerAvailable } = useTicketsNoLongerAvailable()
    useEffect(() => setIsOpen(areTicketsNoLongerAvailable), [areTicketsNoLongerAvailable])

    const {
        pathname,
        query: { slug, id },
    } = useRouter()

    const hide = useCallback(() => {
        setIsOpen(false)
        router.push({ pathname, query: { slug, id } }, undefined, { shallow: true })
    }, [pathname, slug, id])

    useEffect(() => {
        if (isOpen && !timerRef.current) {
            timerRef.current = setTimeout(hide, 3000)
        } else if (!isOpen && timerRef.current) {
            clearTimeout(timerRef.current)
            timerRef.current = undefined
        }
    }, [isOpen, hide])

    useEffect(() => {
        // Clean-up before unmounting
        return () => timerRef.current && clearTimeout(timerRef.current)
    }, [])

    return (
        <>
            <Backdrop zIndex="sheet" isOpen={isOpen} onClick={hide} data-testid="tnla-backdrop" />
            <Sheet centered className={styles.sheet} toggle={isOpen} data-testid="tnla-sheet">
                <CardHeader className={styles.cardHeader} borderBottom={false}>
                    <Icon type="ticket-in-hand" size="xxl" className={styles.icon} />
                    <Text alignment="center" weight="bold" size="lg">
                        This event is hot and tickets are moving fast!
                    </Text>
                </CardHeader>
                <CardBody className={styles.cardBody}>
                    <Text alignment="center" size="md">
                        Please try again or grab even better seats from our incredible selection.
                    </Text>
                </CardBody>
                <CardFooter className={styles.cardFooter} borderTop={false}>
                    <ButtonV2 className={styles.button} onClick={hide} data-testid="tnla-button" importance="tertiary">
                        Grab Tickets
                    </ButtonV2>
                </CardFooter>
            </Sheet>
        </>
    )
}

export default TicketsNoLongerAvailable
